const RecruiterSortEnum = {
  CREATED_AT_ASC: "CREATED_AT_ASC",
  CREATED_AT_DESC: "CREATED_AT_DESC",
};

export default RecruiterSortEnum;
